/* eslint-disable max-lines-per-function */
import { ThreadExtendedActivityFilter, ThreadExtendedActivityTimeframeType } from '@ms/yammer-graphql';
import { Reducer } from 'redux';

import {
  ResetAnalyticsSettingsThreadExtendedActivityForCommunityAnnouncement,
  ResetAnalyticsSettingsThreadExtendedActivityForOthers,
  ResetAnalyticsSettingsThreadExtendedActivityForStorylineAnnouncement,
  SetAnalyticsSettingsSelectNetworkTimeframe,
  SetAnalyticsSettingsSelectNetworkTopThreadStarterSenderFilter,
  SetAnalyticsSettingsSelectThreadExtendedActivityForCommunityAnnouncement,
  SetAnalyticsSettingsSelectThreadExtendedActivityForOthers,
  SetAnalyticsSettingsSelectThreadExtendedActivityForStorylineAnnouncement,
  SetAnalyticsSettingsSelectTopNetworkAnnouncementSortOrder,
  SetAnalyticsSettingsSelectTopNetworkGroupSortOrder,
  SetAnalyticsSettingsSelectTopNetworkThreadSortOrder,
  SetAnalyticsSettingsSelectedUserAction,
} from '../../domains/analyticsSettings/actions.types';

import { defaultAnalyticsSettings } from './mock';
import { AnalyticsSettings } from './types';

export type AnalyticsSettingsAction =
  | SetAnalyticsSettingsSelectedUserAction
  | SetAnalyticsSettingsSelectNetworkTimeframe
  | SetAnalyticsSettingsSelectNetworkTopThreadStarterSenderFilter
  | SetAnalyticsSettingsSelectTopNetworkAnnouncementSortOrder
  | SetAnalyticsSettingsSelectTopNetworkGroupSortOrder
  | SetAnalyticsSettingsSelectTopNetworkThreadSortOrder
  | SetAnalyticsSettingsSelectThreadExtendedActivityForOthers
  | SetAnalyticsSettingsSelectThreadExtendedActivityForStorylineAnnouncement
  | SetAnalyticsSettingsSelectThreadExtendedActivityForCommunityAnnouncement
  | ResetAnalyticsSettingsThreadExtendedActivityForOthers
  | ResetAnalyticsSettingsThreadExtendedActivityForStorylineAnnouncement
  | ResetAnalyticsSettingsThreadExtendedActivityForCommunityAnnouncement;

const initialState = defaultAnalyticsSettings;

const reducer: Reducer<AnalyticsSettings, AnalyticsSettingsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'ANALYTICS_SETTING_SELECTED_USER.SET':
      return { ...state, selectedOnBehalfOfUserId: action.payload.selectedOnBehalfOfUserId };
    case 'ANALYTICS_SETTING_SELECT_NETWORK_TIMEFRAME.SET':
      return {
        ...state,
        networkActivitySettings: { ...state.networkActivitySettings, timeframe: action.payload.timeframe },
      };
    case 'ANALYTICS_SETTING_SELECT_NETWORK_TOP_THREAD_STARTER_SENDER_FILTER.SET':
      return {
        ...state,
        networkActivitySettings: {
          ...state.networkActivitySettings,
          topThreadStarterSenderFilter: action.payload.filterBy,
        },
      };
    case 'ANALYTICS_SETTING_SELECT_TOP_NETWORK_ANNOUNCEMENT_SORT_ORDER.SET':
      return {
        ...state,
        networkActivitySettings: {
          ...state.networkActivitySettings,
          topNetworkAnnouncementSortOrder: action.payload.sortOrder,
        },
      };
    case 'ANALYTICS_SETTING_SELECT_TOP_NETWORK_GROUP_SORT_ORDER.SET':
      return {
        ...state,
        networkActivitySettings: {
          ...state.networkActivitySettings,
          topNetworkGroupSortOrder: action.payload.sortOrder,
        },
      };
    case 'ANALYTICS_SETTING_SELECT_TOP_NETWORK_THREAD_SORT_ORDER.SET':
      return {
        ...state,
        networkActivitySettings: {
          ...state.networkActivitySettings,
          topNetworkThreadSortOrder: action.payload.sortOrder,
        },
      };
    case 'ANALYTICS_SETTING_SELECT_THREAD_EXTENDED_ACTIVITY_FOR_OTHERS.SET':
      return {
        ...state,
        threadExtendedActivitySettingsForOthers: {
          ...state.threadExtendedActivitySettingsForOthers,
          timeframe: action.payload.timeframe,
          includePlatformActivity: action.payload.includePlatformActivity,
          filterEntityId: action.payload.filterEntityId,
          filterBy: action.payload.filterBy,
        },
      };
    case 'ANALYTICS_SETTING_SELECT_THREAD_EXTENDED_ACTIVITY_FOR_STORYLINE_ANNOUNCEMENT.SET':
      return {
        ...state,
        threadExtendedActivitySettingsForStorylineAnnouncement: {
          ...state.threadExtendedActivitySettingsForStorylineAnnouncement,
          timeframe: action.payload.timeframe,
          includePlatformActivity: action.payload.includePlatformActivity,
          filterEntityId: action.payload.filterEntityId,
          filterBy: action.payload.filterBy,
        },
      };
    case 'ANALYTICS_SETTING_SELECT_THREAD_EXTENDED_ACTIVITY_FOR_COMMUNITY_ANNOUNCEMENT.SET':
      return {
        ...state,
        threadExtendedActivitySettingsForCommunityAnnouncement: {
          ...state.threadExtendedActivitySettingsForCommunityAnnouncement,
          timeframe: action.payload.timeframe,
          includePlatformActivity: action.payload.includePlatformActivity,
          filterEntityId: action.payload.filterEntityId,
          filterBy: action.payload.filterBy,
        },
      };
    case 'ANALYTICS_SETTING_THREAD_EXTENDED_ACTIVITY_FOR_OTHERS.RESET':
      return {
        ...state,
        threadExtendedActivitySettingsForOthers: {
          timeframe: ThreadExtendedActivityTimeframeType.TWENTY_EIGHT_DAYS,
          includePlatformActivity: false,
          filterEntityId: undefined,
          filterBy: ThreadExtendedActivityFilter.NONE,
        },
      };
    case 'ANALYTICS_SETTING_THREAD_EXTENDED_ACTIVITY_FOR_STORYLINE_ANNOUNCEMENT.RESET':
      return {
        ...state,
        threadExtendedActivitySettingsForStorylineAnnouncement: {
          timeframe: ThreadExtendedActivityTimeframeType.TWENTY_EIGHT_DAYS,
          includePlatformActivity: true,
          filterEntityId: undefined,
          filterBy: ThreadExtendedActivityFilter.NONE,
        },
      };
    case 'ANALYTICS_SETTING_THREAD_EXTENDED_ACTIVITY_FOR_COMMUNITY_ANNOUNCEMENT.RESET':
      return {
        ...state,
        threadExtendedActivitySettingsForCommunityAnnouncement: {
          timeframe: ThreadExtendedActivityTimeframeType.TWENTY_EIGHT_DAYS,
          includePlatformActivity: true,
          filterEntityId: undefined,
          filterBy: ThreadExtendedActivityFilter.NONE,
        },
      };
    default:
      return state;
  }
};

export default reducer;
